<template>
  <div class="login_container">
    <form action="">
      <div class="login_wrap">
        <img src="images/logo.gif">
        <h2 class="form_title">ISACC Admin</h2>

        <div :class="['login_input', {'has_error': errorFor('email')}]">
          <input type="text" placeholder="Email" v-model="form.email">
          <template v-if="errors && errors.email">
            <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.email" :key="'error_status_'+errorIndex">{{error}}</small>
          </template>
        </div>
        <div  :class="['login_input', {'has_error': errorFor('password')}]">
          <input  type="password" placeholder="Password" v-model="form.password">
          <template v-if="errors && errors.password">
            <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.password" :key="'error_status_'+errorIndex">{{error}}</small>
          </template>
        </div>
        <button class="form__button button_submit" @click.prevent="login">Login</button>
      </div>
    </form>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import validationErrors from "@/mixins/validationErrors";

export default {
  mixins: [validationErrors],
  computed: {
    ...mapGetters({
      appName: 'getAppName'
    })
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
        device: 'web',
      }
    }
  },
  methods: {
    login() {
      this.errors = null;

      this.$store.dispatch('auth/login', this.form)
          .then(() => {
            this.$store.dispatch('auth/getUserPermissions')
            this.$router.push({name:'dashboard'})
          })
          .catch((err) => {
            this.errors = err.errors
          })
          .finally(() => this.loading = false);
    }
  }
}
</script>